import { AuthConfigPanel } from './auth-config-panel';
import type { AuthFormData } from '@/types/integration-form-types';

interface WizardStepAuthProps {
    value: AuthFormData;
    onChange: (auth: AuthFormData) => void;
}

export function WizardStepAuth({ value, onChange }: WizardStepAuthProps) {
    return (
        <AuthConfigPanel value={value} onChange={onChange} />
    );
}
